{
  "name": "eventlistener-manager",
  "version": "1.0.45",
  "description": "The EventManager is capable of handling both native and custom events seamlessly, providing a robust solution for event management in complex applications.",
  "scripts": {
    "test": "echo \"Error: no test specified\" && exit 1",
    "build": "node build.js"
  },
  "author": "",
  "license": "MIT",
  "type": "module",
  "main": "dist/index.cjs",
  "require": "dist/index.cjs",
  "module": "dist/index.mjs",
  "umd": "dist/index.umd.js",
  "types": "dist/src/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.cjs",
      "umd": "./dist/index.umd.js",
      "types": "./dist/src/index.d.ts"
    }
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/pjy0509/eventlistener-manager"
  },
  "homepage": "https://pjy0509.github.io/example/eventlistener-manager/",
  "keywords": [
    "event",
    "eventlistener",
    "listener",
    "gesture",
    "longpress",
    "pan",
    "pinch",
    "javascript",
    "typescript"
  ],
  "devDependencies": {
    "esbuild": "^0.21.4",
    "glob": "^10.4.1",
    "html-webpack-plugin": "^5.6.0",
    "ts-loader": "^9.5.1",
    "typescript": "^5.4.5"
  }
}
